export const log = {
    d: (...args: unknown[]) => console.debug(...args),
    i: (...args: unknown[]) => console.info(...args),
    w: (...args: unknown[]) => console.warn(...args),
    e: (...args: unknown[]) => console.error(...args),
}
